import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import v4 from 'uuid'
import Axios from 'axios'

//const axios = require("axios");

Vue.config.productionTip = false

if(window.localStorage.getItem('geofolio_session_id') == null) {
    window.localStorage.setItem('geofolio_session_id', v4())
}

Vue.prototype.$api = {
}

/* Create a default axios with withCredentials set to true that we can use
   anywhere on our Vue application. */
Vue.prototype.$axios = Axios;
Vue.prototype.$axios.defaults.withCredentials = true;


Vue.mixin({
  data: function() {
    return {        
      get backgroundMaps() {

        return {
          'light': {
            'url': 'https://api.mapbox.com/styles/v1/kokoalberti/ckg1ah7r023sd19o3uk1tc1yt/tiles/256/{z}/{x}/{y}@2x?access_token={accessToken}',
            'label': 'Light'
          },
          'satellite': {
            'url': 'https://api.mapbox.com/styles/v1/kokoalberti/cjm2jwo1033ho2sqngqh1263v/tiles/256/{z}/{x}/{y}@2x?access_token={accessToken}',
            'label': 'Satellite'
          },
          'streets': {
            'url': 'https://api.mapbox.com/styles/v1/kokoalberti/ckg19vj6j2yv719nieoymrgaq/tiles/256/{z}/{x}/{y}@2x?access_token={accessToken}',
            'label': 'Basic'
          },
          'osm': {
            'url': 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            'label': 'OpenStreetMap'
          },
          'landcover': {
            'url': 'https://services.terrascope.be/wmts/v2?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=WORLDCOVER_2020_MAP&STYLE=&FORMAT=image/png&TILEMATRIXSET=EPSG:3857&TILEMATRIX=EPSG:3857:{z}&TILEROW={y}&TILECOL={x}',
            'label': 'Landcover'
          }
        }
      }
    }
  },
  methods: {
    apitoken: function() {
         if (this.$store.state.profile) {
            return this.$store.state.profile.token;
        }
        else if (this.$store.state.profile_pub) {
            return this.$store.state.profile_pub.token;
        }
        else {
            return ''
        }
    },
    getProfile: function() {
        if (this.$store.state.profile) {
            return this.$store.state.profile;
        } else {
            return this.$store.state.profile_pub;
        }
    },
    csrfinit: function() {
      /* Initialize a csrf token */
       this.$axios
           .get(process.env.VUE_APP_API+"/api/csrf-token", { withCredentials: true })
           .then(response => {
              this.$store.commit('csrfinit', response.data.token)
           })
           .catch(error => {
              console.log("Failed to fetch CSRF token.")
           })
    },
    createStart: function() {
        this.$store.commit('createModal', true)
    }, 
    createStop: function() {
        this.$store.commit('createModal', false)
    },
    explainerStart: function(key) {
        this.$store.commit('explainerModal', {'key': key, 'content': null})
    },
    explainerContent: function(html) {
        this.$store.commit('explainerModal', {'key': null, 'content': html})
    },
    explainerStop: function() {
        this.$store.commit('explainerModal', false)
    },
    csrfcookie: function() {
        /* This method is added as a global mixin to obtain the csrftoken from 
           the cookie store. This token needs to be provided in the X-CSRFTOKEN 
           HTTP header when making POST requests for example. */
        var cookieValue = null
        var name = 'geofolio_'+process.env.VUE_APP_STAGE+'_csrftoken';
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    },
    updateprofile: function() {
      /* Update the user profile for the frontend */
      this.$axios
         .get(process.env.VUE_APP_API+"/api/profile", { withCredentials: true })
         .then(response => {
              this.$store.commit('profile', response.data.profile)
              this.$store.commit('profile_pub', response.data.profile_pub)
              this.$store.commit('status', response.data.status)
         })
         .catch(error => {
              console.log("Failed to fetch status from API. Cannot continue.")
              this.$store.commit('status', 2)
         })
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
